import { Grid, Tab, Tabs } from '@material-ui/core'
import React, { useState } from 'react'
import { useStyles } from './work-list-tabs'
import { wlViewTabs } from './const'
import { a11yProps } from 'asterX-UI/Tabs'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { HOLD, MISSED } from 'constants/deals'

export const WorkListTabs = () => {
  const classes = useStyles()

  const {
    store: { wlData },
    actions: { handleUpdateStatus }
  } = useWorkListViewRopStore()

  const [tab, setTab] = useState(0)
  const [changeToHoldOpen, setChangeToHoldOpen] = useState(false)
  const [changeToMissedOpen, setChangeToMissedOpen] = useState(false)

  const TabBody = wlViewTabs[tab].component

  return (
    <Grid container>
      {wlData?.saleStatus &&
        [MISSED].includes(wlData?.saleStatus?.code) &&
        !wlData?.closedByRop && (
          <Grid
            item
            container
            alignItems="center"
            justifyContent="flex-end"
            spacing={3}
            md={6}
            xs={12}
            style={{ marginTop: 20 }}
          >
            <Grid item md={6} xs={12}>
              <AsterButton
                fullWidth
                color="negative"
                onClick={() => setChangeToHoldOpen(true)}
              >
                Вернуть в работу
              </AsterButton>
            </Grid>
            <Grid item md={6} xs={12}>
              <AsterButton
                fullWidth
                color="primary"
                onClick={() => setChangeToMissedOpen(true)}
              >
                Согласовать закрытие
              </AsterButton>
            </Grid>
          </Grid>
        )}
      <Grid item container style={{ marginBottom: 24 }}>
        <Tabs
          className={classes.wlViewTabs}
          value={tab}
          onChange={(e, value) => setTab(value)}
        >
          {wlViewTabs.map(({ label }, i) => (
            <Tab
              key={`wl-view-tab-${i}`}
              label={label}
              value={i}
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item container>
        <TabBody {...(wlData || {})} />
      </Grid>

      <ActionModal
        open={changeToHoldOpen}
        onClose={() => setChangeToHoldOpen(false)}
        onCancel={() => setChangeToHoldOpen(false)}
        onConfirm={() => {
          setChangeToHoldOpen(false)
          handleUpdateStatus(HOLD)
        }}
        title="Вы уверены что хотите вернуть в работу ?"
      />

      <ActionModal
        open={changeToMissedOpen}
        onClose={() => setChangeToMissedOpen(false)}
        onCancel={() => setChangeToMissedOpen(false)}
        onConfirm={() => {
          setChangeToMissedOpen(false)
          handleUpdateStatus(MISSED)
        }}
        title="Вы уверены что хотите cогласовать закрытие ?"
      />
    </Grid>
  )
}
